import { render, staticRenderFns } from "./shared-error.vue?vue&type=template&id=52a788c4"
import script from "./shared-error.vue?vue&type=script&lang=js"
export * from "./shared-error.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports